<template lang="pug">
v-container(fluid).user-search-form
  v-layout
    v-flex
      user-search-form-field(ref="field_1")
  v-layout
    v-flex
      user-search-form-field(
        v-if="field_2"
        ref="field_2")
  v-layout(justify-space-between)
    v-flex
      v-btn(
        dark
        :color="field_2 ? 'error' : 'primary'"
        @click="field_2 = !field_2") {{ field_2 ? '刪除第二條件' : '新增第二條件' }}
          v-icon add
  v-dialog(v-model="loading")
    v-card(
      color="primary"
      dark)
      v-card-text 搜尋中...
      v-progress-linear(
        indeterminate
        color="white"
        class="mb-0")
</template>

<script>
import { db } from "@/firebase";
import UserSearchFormField from "@/components/forms/UserSearchFormField.vue";

export default {
  name: "UserSearchForm",
  components: {
    UserSearchFormField
  },
  data() {
    return {
      loading: false,
      field_2: false
    };
  },
  methods: {
    async submit() {
      this.loading = true;

      const fieldList = ["field_1"];

      if (this.field_2) {
        fieldList.push("field_2");
      }

      let invalid = false,
        formData = {};

      fieldList.forEach(field => {
        const data = this.$refs[field].submit();

        if (!data) {
          invalid = true;
        } else {
          formData[field] = data;
        }
      });

      if (invalid) {
        return false;
      }

      let users = db.collection("users");

      fieldList.forEach(field => {
        const { key, value } = formData[field];
        users = users.where(key, "==", value);
      });

      const snap = await users.get();
      const list = [];

      snap.forEach(doc => {
        const item = doc.data();
        item.uid = doc.id;
        list.push(item);
      });

      this.$emit("submit-succeed", list);
      this.loading = false;

      return list;
    }
  }
};
</script>
